import { i18n } from '@lingui/core';
import { IconInfoCircle } from '@tabler/icons';
import BookitupAlert from './BookitupAlert';

const QuestionnaireAlert = () => (
  <BookitupAlert mb="sm" icon={<IconInfoCircle />} title="Sind im PDF große Bereiche weiß? Dieser Tipp hilft Dir!">
    {i18n._('questionnaire.tip.helper')}
  </BookitupAlert>
);

export default QuestionnaireAlert;
